<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-fade-transition mode="out-in">
          <a-authorization-card
            v-if="erreur"
            class="ma-5"
            color="error"
            icon="mdi-cancel"
            title="Oups..."
            text="Aucun dépôt ne correspond à cette URL."
          />
          <v-form readonly="true" v-else-if="charge">
            <v-stepper alt-labels v-model="step">
              <v-stepper-header>
                <v-stepper-step
                  v-for="s of steps"
                  edit-icon="$complete"
                  :key="s.step + 's'"
                  :step="s.step"
                  :editable="true"
                >
                  {{ s.text }}
                </v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                <v-stepper-content :step="1">
                  <v-textarea
                    label="Observation"
                    filled
                    v-model="item.commentaire"
                    hint="Pour toute information complémentaire"
                    persistent-hint
                    data-testid="observation"
                  />
                  <a-declarant-sheet v-model="item.declarant" depot />
                </v-stepper-content>
                <v-stepper-content :step="2">
                  <a-association-sheet v-model="item.association" depot />
                </v-stepper-content>
                <v-stepper-content :step="3">
                  <a-membres-sheet v-model="item.membres" depot />
                </v-stepper-content>
                <v-stepper-content :step="4">
                  <a-annexe-sheet v-model="item.annexes" depot />
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-form>
          <v-skeleton-loader
            v-else
            loading
            type="card-heading, actions, card, sentences"
          />
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { requeteService } from "@/services";
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      charge: false,
      erreur: false,
      item: {
        declarant: {},
        association: {},
        annexes: { annexes: [] },
        membres: {
          comite: {
            physiques: [],
            morales: [],
          },
          fondateurs: {
            physiques: [],
            morales: [],
          },
        },
        commentaire: null,
      },
      step: 1,
      steps: [
        { text: "Déclarant" },
        { text: "Association" },
        { text: "Membres" },
        { text: "Annexes" },
      ].map(({ text }, index) => ({
        step: index + 1,
        text,
      })),
    };
  },
  mounted() {
    this.chargeAssociation();
  },
  methods: {
    chargeAssociation() {
      requeteService
        .depot(this.id)
        .then(body => {
          this.charge = true;
          const item = this.item;
          item.commentaire = body.commentaire;
          item.declarant = body.declarant;
          item.association = body.association;
          item.membres.comite = body.comite;
          item.membres.fondateurs = body.fondateurs;
          item.annexes.annexes = body.annexes.map(a => ({
            ...a,
            lien: `/api/depot/${this.id}/fichier/${a.index}/${a.nom}`,
          }));
        })
        .catch(() => {
          this.erreur = true;
        });
    },
  },
};
</script>

